const MAX_FILE_SIZE_IN_MB = 2;
const MAX_FILE_SIZE_IN_BYTES = MAX_FILE_SIZE_IN_MB * 1024 * 1024;
const MAX_FILE_COUNT = 3;

export const ATTACH_DOCUMENTS = {
  MAX_FILE_SIZE_IN_MB,
  MAX_FILE_SIZE_IN_BYTES,
  MAX_FILE_COUNT,
};
